<template>
  <div>
    <div class="title-customer">
      <h2 class="title is-size-5">顧客情報</h2>
      <a
        href="https://auction.japan-carrier.com/manage/customer"
        target="_blank"
        class="jc-auction is-size-5"
        >顧客情報管理</a
      >
    </div>
    <b-field grouped>
      <b-field label="顧客名" expanded>
        <b-input v-model="item.customerName"  :disabled="checkEditPrice"></b-input>
      </b-field>
      <b-field
        label="顧客ID"
        :type="listErrType.errId"
        :message="listMsgValidation.msgId"
      >
        <b-autocomplete
          :data="filteredCustomer"
          field="customer_id_format"
          :value="item.customerId"
          v-model="customerId"
          @select="setCustomerInf"
          @input="validateInput('顧客ID')"
          placeholder="Choose CustomerId"
          open-on-focus
          clearable
          :disabled="checkEditPrice"
        >
        </b-autocomplete>
      </b-field>
      <b-field
        label="Grade"
        expanded
        :type="listErrType.errGrade"
        :message="listMsgValidation.msgGrade"
      >
        <b-input
          v-model="item.customerGrade"
          @input="validateInput('Grade')"
           :disabled="checkEditPrice"
        ></b-input>
      </b-field>
    </b-field>
    <b-field grouped>
      <b-field
        label="電話番号"
        expanded
        :type="listErrType.errTel"
        :message="listMsgValidation.msgTel"
      >
        <b-input
          v-model="item.customerTel"
          @input="validateInput('電話番号')"
           :disabled="checkEditPrice"
        ></b-input>
      </b-field>
    </b-field>
  </div>
</template>
<style>
.title-customer {
  display: flex;
}
.jc-auction {
  margin-left: 15px;
  font-size: 15px !important;
  text-decoration: revert;
  font-weight: bold;
}
</style>
<script>
const regexFormatNumber = /^[0-9]+$/;
const regexFormatAlphabet = /^[A-E]+$/;
import itemRespository from '@/repositories/item';
export default {
  props: ['item', 'listCustomerInf','checkEditPrice'],
  data: () => ({
    isSave: true,
    customerIdFormat: '',
    customerId: '',
    listMsgValidation: {
      msgId: '',
      msgGrade: '',
      msgTel: '',
    },
    listErrType: {
      errId: '',
      errGrade: '',
      errTel: '',
    },
  }),
  async created() {
    this.customerId = this.item.customerId || '';
  },
  computed: {
    filteredCustomer() {
      return this.listCustomerInf.filter(
        (option) =>
          option.customer_id_format
            .toUpperCase()
            .indexOf(this.customerId.toUpperCase()) >= 0
      );
    },
  },
  methods: {
    async setCustomerInf(customer) {
      if (customer) {
        this.customerId = customer.customer_id_format;
        this.item.customerId = customer.customer_id_format;
        this.item.customerName = customer.customer_name;
        this.item.customerGrade = customer.trnsprtgrd;
        this.item.customerTel = customer.phone_number;
        if (this.item.matterNo) {
          let filterTemp = [];
          this.$store.commit('isLoadingApi', true);
          filterTemp = await itemRespository.getListUpdateCustomers(this.item.matterNo);
          if (filterTemp.length > 0) {
            filterTemp.forEach( async(res) => {
              res.customerId = customer.customer_id_format;
              res.customerName = customer.customer_name;
              res.customerGrade = customer.trnsprtgrd;
              res.customerTel = customer.phone_number;
              await itemRespository.save(res);
            })
          }
          this.$store.commit('isLoadingApi', false);
        }
        
      }
      this.validateInput('顧客ID');
    },
    validation() {
      this.validateInput('顧客ID');
    },
    validateInput(id) {
      switch (id) {
        case '顧客ID':
          if (this.customerId == '') {
            this.listErrType.errId = 'is-danger';
            this.listMsgValidation.msgId =
              '顧客ＩＤの入力がありません。顧客IDを入力してください。';
            this.isSave = false;
            this.item.customerId = '';
            break;
          }
          this.customerIdFormat = '';
          this.listCustomerInf.find((v) => {
            if (v.customer_id_format == this.customerId) {
              this.customerIdFormat = v.customer_id_format;
            }
          });
          if (
            !regexFormatNumber.test(this.customerId) ||
            this.customerIdFormat == ''
          ) {
            this.listErrType.errId = 'is-danger';
            this.listMsgValidation.msgId =
              '入力された顧客IDが存在しません。正しい顧客IDを入力してください。';
            this.isSave = false;
            break;
          }
          this.listErrType.errId = '';
          this.listMsgValidation.msgId = '';
          this.isSave = true;
          break;
        case 'Grade':
          if (regexFormatAlphabet.test(this.item.customerGrade)) {
            this.listErrType.errGrade = '';
            this.listMsgValidation.msgGrade = '';
            this.isSave = true;
          } else {
            this.listErrType.errGrade = 'is-danger';
            this.listMsgValidation.msgGrade =
              '顧客のGradeに誤りがあります。大文字アルファベットで入力してください。';
            this.isSave = false;
          }
          break;
        case '電話番号':
          if (regexFormatNumber.test(this.item.customerTel)) {
            this.listErrType.errTel = '';
            this.listMsgValidation.msgTel = '';
            this.isSave = true;
          } else {
            this.listErrType.errTel = 'is-danger';
            this.listMsgValidation.msgTel =
              '電話番号に不正な文字が入力してください。ハイフンなしの数字のみ入力してください。';
            this.isSave = false;
          }
          break;
        default:
          break;
      }
      this.$emit('responeValidateItemCustomer', this.listMsgValidation);
    },
  },
};
</script>
